export const TEST_ID = 'detailsViewCardApplicationsListContainer';
